import { Interaction_Modality_Code } from 'generated/types';
export var PROHIBITED_INTERACTION_MODALITIES = [
    Interaction_Modality_Code.AnnualPhysicalForm,
    Interaction_Modality_Code.Appointment,
    Interaction_Modality_Code.CarePlan,
    Interaction_Modality_Code.Claim,
    Interaction_Modality_Code.FinancialDataValue,
    Interaction_Modality_Code.ScheduledFollowUp,
    Interaction_Modality_Code.MailOrderTransfer,
    Interaction_Modality_Code.DiabetesProgram,
    Interaction_Modality_Code.SeldonBeattieForm,
    Interaction_Modality_Code.ProactiveDrug,
    Interaction_Modality_Code.MedicalNavigation,
    Interaction_Modality_Code.BenefitInquiry,
    Interaction_Modality_Code.DrugListUpdateRequest,
    Interaction_Modality_Code.PriorAuthorizationStatus,
    Interaction_Modality_Code.WeightManagementProgram,
    Interaction_Modality_Code.AccumulatorIssue,
    Interaction_Modality_Code.PriorAuthorization,
    Interaction_Modality_Code.Override,
    Interaction_Modality_Code.Common,
    Interaction_Modality_Code.VendorSetup,
    Interaction_Modality_Code.NewImplementation,
    Interaction_Modality_Code.GroupTerming,
    Interaction_Modality_Code.ClaimFileProcessings,
    Interaction_Modality_Code.ImpactReport,
    Interaction_Modality_Code.PlanChangeHandling,
    Interaction_Modality_Code.FertilityMaximum,
    Interaction_Modality_Code.AccumulatorChange,
    Interaction_Modality_Code.GroupNumberChange,
    Interaction_Modality_Code.EligibilityInquiry
];
export var modalitiesFilterFn = function (item) { return PROHIBITED_INTERACTION_MODALITIES.indexOf(item.name) === -1; };
export var disallowedModalitiesSet = new Set(PROHIBITED_INTERACTION_MODALITIES);
export var commonOptions = [
    Interaction_Modality_Code.TextMessage,
    Interaction_Modality_Code.Phonecall,
    Interaction_Modality_Code.Email
];
